export const STATUS_ITEMS = ['Ativo', 'Inativo','Pendente']
export const TIPO_IMOVEL_CONDOMINIUM_ITEMS = ['Apartamento', 'Casa', 'Sala Comercial', 'Galpão', 'Terreno', 'Apartamento / Sala Comercial', 'Casa / Terreno']
export const ESTADO_CONDOMINIUM_ITEMS = ['Pronto', 'Lançamento', 'Breve Lançamento', 'Em construção']
export const FINALIDADES_CONDOMINIUM_ITEMS = ['Residencial', 'Comercial', 'Industrial', 'Residencial / Comercial']
export const SIM_NAO_ITEMS = ['Sim', 'Não']
export const REGIOES_IMOVEL_ITEMS = ['Urbana', 'Litoral', 'Campo']
export const COLABORATOR_DESCRIPTIONS = ['Captador','Colaborador Venda','Colaborador Locaçāo','Plantonista']
